const favorites = {
  favorites: {
    title: 'المفضلة',
    subtitle: '{{count}} عقار محفوظ في {{listCount}} قائمة',
    lists: {
      title: 'القوائم',
      newList: 'قائمة جديدة',
      defaultName: 'المفضلة',
      editList: 'تعديل القائمة',
      deleteList: 'حذف القائمة',
      deleteConfirm: "حذف '{{name}}'؟ لا يمكن التراجع عن هذا الإجراء.",
      deleteWarning: 'سيتم نقل جميع العقارات إلى القائمة الافتراضية',
      propertyCount: '{{count}} عقار',
      propertyCountSingular: 'عقار واحد',
      createPlaceholder: 'مثال: للزيارة',
      name: 'اسم القائمة',
      color: 'اللون',
      icon: 'الأيقونة',
    },
    recentlySaved: {
      title: 'المحفوظة مؤخراً',
      addedAgo: 'أضيف {{time}}',
    },
    empty: {
      title: 'لا توجد عقارات محفوظة',
      description: 'ابدأ بإضافة العقارات إلى المفضلة من صفحة البحث',
      cta: 'تصفح العقارات',
      listEmpty: 'لا توجد عقارات في هذه القائمة',
    },
    listPicker: {
      title: 'حفظ في قائمة',
      addToList: 'إضافة إلى {{name}}',
      inList: 'في {{name}}',
      createNew: 'إنشاء قائمة جديدة',
      remove: 'إزالة من جميع القوائم',
      propertyCount: '{{count}} عقارات',
      propertyCount_one: 'عقار واحد',
      addedToList: 'تمت الإضافة للقائمة',
      removedFromList: 'تمت الإزالة من القائمة',
      error: 'فشل تحديث القائمة',
      newListPlaceholder: 'أدخل اسم القائمة',
      cancel: 'إلغاء',
      create: 'إنشاء',
      listCreated: 'تم إنشاء قائمة "{{name}}"',
      createError: 'فشل إنشاء القائمة',
    },
    toast: {
      saved: 'تم الحفظ في {{name}}',
      removed: 'تمت الإزالة من المفضلة',
      listCreated: 'تم إنشاء القائمة "{{name}}"',
      listUpdated: 'تم تحديث القائمة',
      listDeleted: 'تم حذف القائمة',
      bulkRemoved: 'تمت إزالة {{count}} عقار',
    },
    hint: {
      tapToSave: 'اضغط للحفظ',
      dismiss: 'فهمت',
    },
    selection: {
      selectMode: 'تحديد',
      selected: '{{count}} محدد',
      removeSelected: 'إزالة المحدد',
      cancel: 'إلغاء',
      selectAll: 'تحديد الكل',
      deselectAll: 'إلغاء تحديد الكل',
    },
    viewModes: {
      grid: 'شبكة',
      list: 'قائمة',
    },
    actions: {
      viewDetails: 'عرض التفاصيل',
      remove: 'إزالة',
      edit: 'تعديل',
      delete: 'حذف',
      save: 'حفظ',
      cancel: 'إلغاء',
      create: 'إنشاء',
      saveChanges: 'حفظ التغييرات',
    },
    loading: 'جاري التحميل...',
  },
};

export default favorites;
